// TODO: use routes.js as single source of truth, e.g. build prefix tree from paths with route as data, then transform tree

export function findRouteByName(root, routeName) {
  if (root.name === routeName) {
    return [root]
  }
  else if (root.children) {
    for (const node of root.children) {
      const nodes = findRouteByName(node, routeName)
      if (nodes.length > 0) {
	return [root, ...nodes]
      }
    }
  }

  return []
}

export const routes = {
  name: 'Home',
  children: [
    {
      name: 'Search',
      label: 'Search'
    },
    {
      name: 'About',
      label: 'About'
    },
    {
      name: 'Directory',
      label: 'Directory',
      children: [
	{
	  name: 'Document',
	  label: ({ document }) => console.log(document),
	  paramNames: ['documentId'],
	  children: [
	    {
	      name: 'PageDetail',
	      label: ({ pageNum }) => `Seite ${pageNum}`,
	      paramNames: ['documentId', 'pageNum']
	    }
	  ]
	}
      ]
    }
  ]
}

function parsePath(path) {
  // TODO: deal with routes description

  const segments = path.split('/')

  while (segments[0] === '') {
    segments.shift()
  }

  while (segments[segments.length - 1] === '') {
    segments.pop()
  }

  return segments
    .filter((segment) => segment !== '')
    .reduce((arr, val) => {
      if (val.startsWith(':')) {
	arr[arr.length - 1].params = [
	  ...arr[arr.length - 1].params || [],
	  val.slice(1)
	]
	return arr
      }
      else {
	return [
	  ...arr,
	  { segment: val }
	]
      }
    }, [])
}
